import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserNotificationAction } from '@arc/arc-shared-frontend';
import { EMPTY, exhaustMap, of } from 'rxjs';
import {
  HostedPaymentsPadResultComponentSessionActions,
  HostedPaymentsSelectPaymentMethodSessionActions,
  PoaPadResultComponentSessionActions,
  PoaSelectPaymentMethodSessionActions,
  PoiPadResultComponentSessionActions,
  PoiSelectPaymentMethodSessionActions,
} from '../component-actions';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Injectable()
export class SharedSessionEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private translate: TranslateService,
  ) {}

  displayPadTwikeyRedirectError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PoiSelectPaymentMethodSessionActions.updateSessionRedirectStateError,
        PoaSelectPaymentMethodSessionActions.updateSessionRedirectStateError,
        HostedPaymentsSelectPaymentMethodSessionActions.updateSessionRedirectStateError,
      ),
      exhaustMap(() =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              'ARC_PAYMENT_PAD_REDIRECT_ERROR',
            ) as string,
          }),
        ),
      ),
    ),
  );

  handleLoadSessionRedirectStateError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          PoiPadResultComponentSessionActions.loadSessionRedirectStateError,
          PoaPadResultComponentSessionActions.loadSessionRedirectStateError,
          HostedPaymentsPadResultComponentSessionActions.loadSessionRedirectStateError,
        ),
        exhaustMap(() => {
          this.router.navigate(['/pad/error']);
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );
}
